<div class="col-md py-2 d-flex justify-content-center">
    <div class="logo_garsan">
        <a routerLink="/" routerLinkActive="active">
            <img src='/assets/images/logo-principal.jpg' alt='Logo Gar-San' class="img-fluid">
        </a>
    </div>
</div>
<div>
    <!-- {{getScreenWidth}} -->
</div>